import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import settingsAPI from "@/api/settings";

import router from '@/router'

import institutions from './institutions'
import departments from './departments'
import teachers from './teachers'
import indicators from './indicators'
import periods from './periods'

const SET_HEADERS = 'SET_HEADERS'
const SET_TOKEN = 'SET_TOKEN'
const SET_USER_INFO = 'SET_USER_INFO'

const ROLE_ADMIN = 'ROLE_ADMIN'
const ROLE_MANAGER = 'ROLE_MANAGER'
const ROLE_HEAD = 'ROLE_HEAD'
const ROLE_CONFIGURATOR = 'ROLE_CONFIGURATOR'

export default new Vuex.Store({
  state: {
    headers: null,
    user: {},
    token: '',
    settings: {}
  },
  modules: {
    institutions,
    departments,
    teachers,
    indicators,
    periods
  },
  getters: {
    getResponseHeaders: (state) => {
      return state.headers
    },
    isUserLoggedIn: (state) => {
      return state.token && state.token.length > 0
    },
    isUserAdmin: (state, getters) => {
      return getters.isUserLoggedIn && state.user.roles && state.user.roles.includes(ROLE_ADMIN)
    },
    isUserManager: (state, getters) => {
      return getters.isUserAdmin || (state.user.roles && (state.user.roles.includes(ROLE_MANAGER) || state.user.roles.findIndex(role => role.startsWith(ROLE_MANAGER) === true) >= 0))
    },
    isUserSuperManager: (state, getters) => {
      return getters.isUserAdmin || (state.user.roles && state.user.roles.includes(ROLE_MANAGER))
    },
    managerRole: (state, getters) => {
      if (getters.isUserManager && state.user.roles) {
        const role = state.user.roles.find(role => role.startsWith(ROLE_MANAGER))
        if (role) {
          return role.substring(5)
        }
      }

      return null
    },
    isUserHead: (state, getters) => {
        return state.user.roles && state.user.roles.includes(ROLE_HEAD)
    },
    isUserConfigurator: (state, getters) => {
      return getters.isUserAdmin || (state.user.roles && state.user.roles.includes(ROLE_CONFIGURATOR))
    },
    settings (state) {
      return state.settings
    },
    userDepartment (state) {
      return state.user ? state.user.department : null
    },
  },
  mutations: {
    [SET_HEADERS]: (state, headers) => {
      state.headers = headers
    },
    [SET_TOKEN]: (state, token) => {
      state.token = token
    },
    [SET_USER_INFO]: (state, user) => {
      state.user = user
    },
    SET_SETTINGS (state, settings) {
      for (let key in settings) {
        Vue.set(state.settings, key, settings[key])
      }
    }
  },
  actions: {
    signIn: async ({commit}, { username, password }) => {
      commit(SET_TOKEN, '')
      let formData = new FormData()
      formData.append('username', username)
      formData.append('password', password)
      return Vue.axios.post('/auth/login', formData)
    },
    signOut: ({commit}) => {
      commit(SET_TOKEN, '')
    },
    getUserInfo: ({commit, dispatch}, user) => {
      if (!user || !user.id) {
        dispatch('signOut').then(() => {
          router.push({name: 'home'})
        })
      } else {
        return Vue.axios.get('/user/' + user.id + '/info').then((response) => {
          if (response.success) {
            commit(SET_USER_INFO, response.user)
          }
        })
      }
    },
    async loadSettings ({ commit }, { options }) {
      const { settings } = await settingsAPI.loadSettings(options)
      commit('SET_SETTINGS', settings)
    },
    async saveSettings ({ commit }, { options }) {
      const { settings } = await settingsAPI.saveSettings(options)
      commit('SET_SETTINGS', settings)
    },
    async saveUserContacts ({ commit, state }, contacts) {
      const formData = new FormData()
      formData.append('email', contacts.email)
      formData.append('phone', contacts.phone)
      formData.append('mobile', contacts.mobile)

      Vue.axios.post(`/user/${state.user.id}/contacts`, formData)
          .then((response) => {
            commit(SET_USER_INFO, response.user)
          })
    }
  }
})

export { SET_HEADERS, SET_TOKEN }
